<template>
  <div>
    <PhotoInput
      @change="savePhoto"
      :photo="logo"
    />
  </div>
</template>

<script>
import PhotoInput from '@/components/PhotoInput.vue';

export default {
  name: 'CompanyProgramLogo',
  components: {
    PhotoInput,
  },
  props: {
    companyProgram: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      logo: this.companyProgram.logo,
    };
  },
  methods: {
    async savePhoto(photoFile) {
      if (!photoFile) return;

      const formData = new FormData();
      formData.set('progid', this.companyProgram.id);
      formData.set('name', 'new program logo');
      formData.append('file1', photoFile);

      const result = await this.$store.dispatch('editProgramLogo', formData);

      if (!result) {
        this.$toasted.global.appError({ errorMessage: 'Program logo could not be uploaded, please try again.' });
      } else {
        this.$toasted.success('Program logo saved!', {
          duration: 3000,
          position: 'top-right',
        });

        this.$emit('saved');

        // todo
        // this.$store.dispatch('logAction', this.$store.state.Logger.actionsIndexes.changeCompanyLogo);
      }
    },
  },
  created() {
    // get company then
  },
};
</script>

<style>

</style>
